import { useCallback, useEffect, useState } from "react";
import { getCountries } from "../../services/masterDataService";

const useCountry = () => {
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);
  const [sortThaiDictionary, setSortThaiDictionary] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getCountries();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);

      const countriesOptions = [
        { label: "เลือกทั้งหมด", value: "all" },
        ...objectValue.map((item) => ({
          label: item.countryNameTh,
          value: item.countryId,
        })),
      ];

      const filterCountries = countriesOptions.filter(v => v.value !== "all")
      const newList = [...filterCountries];
      newList.sort((a, b) => a.label.localeCompare(b.label, 'th'));
      setSortThaiDictionary(newList);

      setOptions(countriesOptions);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data, options, sortThaiDictionary];
};

export default useCountry;
